import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { useAdmin } from '../AdminContext';
import { unplannedDesigns } from './designPlanning';
type TabKey = 'planning' | 'ontwerpen' | 'merkstijl';
const tabs: {
  key: TabKey;
  to: string;
  label: string;
}[] = [{
  key: 'planning',
  to: '/be/social',
  label: 'Planning'
}, {
  key: 'ontwerpen',
  to: '/be/ontwerpen',
  label: 'Ontwerpen'
}, {
  key: 'merkstijl',
  to: '/be/ontwerpen?tab=merkstijl',
  label: 'Merkstijl & teksten'
}];

/**
 * Social en Ontwerpen horen bij elkaar: je maakt een ontwerp en plant het in. Eén tabrij bovenaan
 * beide schermen, zodat Sarah er zonder het menu tussen wisselt (BEHEER-PLAN §11, fase 5).
 * De adressen blijven zoals ze waren.
 */
export function MarketingTabs() {
  const {
    pathname
  } = useLocation();
  const [params] = useSearchParams();
  const {
    marketing
  } = useAdmin();
  const waiting = unplannedDesigns(marketing.designs, marketing.posts).length;
  const active: TabKey = pathname.startsWith('/be/social') ? 'planning' : params.get('tab') === 'merkstijl' ? 'merkstijl' : 'ontwerpen';
  return <nav aria-label="Marketing" className="-mx-4 mb-6 overflow-x-auto px-4 sm:mx-0 sm:px-0 [scrollbar-width:none]" data-id="element-3087" data-mp="ic4xsjdmchy8">
      <ul className="flex min-w-max gap-6 border-b border-line" data-id="element-3088" data-mp="naooex35qhwx">
        {tabs.map(t => {
        const on = t.key === active;
        return <li key={t.key} data-id="element-3089" data-mp="s8813sk7immr">
              <Link to={t.to} aria-current={on ? 'page' : undefined} className={`relative inline-flex min-h-11 items-center gap-2 whitespace-nowrap pb-3 pt-2 text-[14px] transition-colors duration-150 ease-soft sm:min-h-0 sm:pt-1 ${on ? 'text-ink after:absolute after:inset-x-0 after:-bottom-px after:h-0.5 after:bg-ink' : 'text-muted hover:text-ink'}`} data-id="element-3090" data-mp="x9nmjlqaqv5o">
                {t.label}
                {t.key === 'ontwerpen' && waiting > 0 && <span className="min-w-[1.25rem] rounded-full bg-sand px-1.5 text-center text-[11px] leading-5 tabular-nums text-ink ring-1 ring-line" data-id="element-3091" data-mp="1kzrrpxj4v2ys">
                    {waiting}
                    <span className="sr-only" data-id="element-3092" data-mp="qcsx53627niq"> {waiting === 1 ? 'ontwerp nog niet ingepland' : 'ontwerpen nog niet ingepland'}</span>
                  </span>}
              </Link>
            </li>;
      })}
      </ul>
    </nav>;
}